import app_image from './img/app.jpg';
import grocery_image from './img/grocery.jpg';
import news_image from './img/news.jpg';
import clothes_image from './img/clothes.jpg';


import timeblocking_image from './img/TimeBlocking.jpeg'
import recipe_image from './img/Recipe.jpeg'
import habittracking_image from './img/HabitTracking.jpeg'
import coloring_image from './img/Coloring.jpeg'


const POSTS = {
  // 1: Time Blocking Planner
  0: {
    id: 1,
    creator: 'RrO8DxMzB1VRpIDpVeed',
    product_install_message: `
    📅 Maximize Your Productivity with Time Block Planner PDF! 🚀📝 
    
    🕒 Take control of your day like never before!
    🎯 Organize tasks, set priorities, and achieve your goals with ease using our Time Block Planner PDF. 💼✨
    
    🔹 Boost productivity 🔹 Stay focused and on track 🔹 Accomplish more in less time!
    
    🎁 Download now and unlock your full potential!`,
    content: 'Master Time, Unleash Productivity: Time Block Planner PDF 🚀📅 - only $0.1!',
    attachments: [
      {
        type: 'image/jpeg',
        //url: 'https://lh3.googleusercontent.com/E0gjXlphm-JI271hmRVtWqPu4FGZd3SmMbYPyIJG_34uQyU74C8Sh0IHN7wu2DIo8qE=w1024-h683-p'
        //url: 'https://drive.google.com/uc?export=view&id=1kk_zbO2TCbbifx4VNF3D86tX7nDApB4S'
        url: timeblocking_image
      }
    ],
    createdAt: new Date(1640259923075),
    button_message: {Y: "Purchase Now", N: "Learn More"},
    popup_description: "Please click the 'Purchase' button below to download Time Block Planner PDF for only $0.1",
    popup_button_text: "Purchase",
    ad_post_question_message: "You purchased it",
    post_subtitle: "Sep 14 at 09:30 AM"
  },


  // 2: Coloring book
  1: {
    id: 2,
    creator: '2Ro1Ltf9fNmh4qgTcPRR',
    product_install_message: `🌿🎨 Discover Nature's Beauty - Tree & Plant Coloring Book! 🌳🌷 Unwind with intricate illustrations, add vibrant colors to nature's wonders. 🌺🍂 Relieve stress effortlessly. 🌱💆‍♀️ Perfect for all ages - a delightful gift for nature enthusiasts! 🎁🎨 Bring nature to life! 🌿🌸 `,
    content: "Color Nature's Serenity: Tree & Plant Coloring Book 🌿🎨✨ - only $0.1!",
    attachments: [
      {
        type: 'image/jpeg',
        //url: 'https://drive.google.com/uc?export=view&id=1TUqUxdhm_ZmDJitvITsR7NDzoskLMfcn'
        url: coloring_image
      }
    ],
    createdAt: new Date(1640259825388),
    button_message: {Y: "Purchase Now", N: "Learn More"},
    popup_description: "Please click the 'Purchase' button below to download the Tree & Plant Coloring Book PDF for only $0.1",
    popup_button_text: "Purchase",
    ad_post_question_message: "You purchased it",
    post_subtitle: "Sep 14 at 01:20 PM"
  },
  
  // 3: Chocolate Chip Cookies Recipe
  2: {
    id: 3,
    creator: 'nWerxL1cZWDsQMlEU5w0',
    product_install_message: `🍪🍫 Indulge in Sweet Delights - Try Our Chocolate Chip Cookies Recipe! 🍪🍫 Bake mouthwatering cookies with gooey chocolate chips. 😋🍪 Perfect for all occasions - a treat for your taste buds! 🎉👩‍🍳 Impress family and friends with homemade goodness. 🏡🍪 Get the recipe now!`,
    content: 'Sweet Bliss in Every Bite - Chocolate Chip Cookies Recipe 🍪🍫✨ - only $0.1!',
    attachments: [
      {
        type: 'image/jpeg',
        //url: 'https://drive.google.com/uc?export=view&id=19U-pCOcXnv-V9wSxPIWltDHAbFp0Sdi5'
        url: recipe_image
      }
    ],
    createdAt: new Date(1640259670891),
    button_message: {Y: "Purchase Now", N: "Learn More"},
    popup_description: "Please click the 'Purchase' button below to download the chocolate chips cookies recipe PDF for only $0.1",
    popup_button_text: "Purchase",
    ad_post_question_message: "You purchased it",
    post_subtitle: "Sep 14 at 11:05 AM"
  },
  // 4: Habit Tracking
  3: {
    id: 4,
    creator: 'TnUpw8Ap6ttd7UOYTtMq',
    product_install_message: `📅📝 Crush Your Goals - Download our Habit Tracker Template! 🚀🎯 Stay organized and track your progress effortlessly. 🌟📊 Build positive habits and break free from the old ones. 🔄💪 Perfect for personal growth and success! 🌱🏆 Get started now! 👉 `,
    content: 'Track, Transform, Triumph - Habit Tracker Template 📅📊💪  - only $0.1!',
    attachments: [
      {
        type: 'image/jpeg',
        //url: 'https://drive.google.com/uc?export=view&id=19U-pCOcXnv-V9wSxPIWltDHAbFp0Sdi5'
        url: habittracking_image
      }
    ],
    createdAt: new Date(1640259670891),
    button_message: {Y: "Purchase Now", N: "Learn More"},
    popup_description: "Please click the 'Purchase' button below to download the habit tracking template PDF for only $0.1",
    popup_button_text: "Purchase",
    ad_post_question_message: "You purchased it",
    post_subtitle: "Sep 14 at 05:45 PM"
  }
}


const POSTS_old = {
  /* --- Id: 1 - Political --- */
  1: {
    id: 1,
    creator: 'RrO8DxMzB1VRpIDpVeed',
    content: 'The Trump administration worked to free 5,000 Taliban prisoners.\n\nA 2020 agreement between the U.S. and the Taliban called for the release of up to 5,000 Taliban prisoners who were held by the Afghan government.\nNews reports and statements from Afghanistan’s president indicate that the release happened. Afghanistan officials said they freed the prisoners at the request of the U.S.',
    attachments: [
      {
        type: 'image/jpeg',
        url: 'https://firebasestorage.googleapis.com/v0/b/chatbox-v01.appspot.com/o/images%2F1.jpg?alt=media&token=e55a8834-0cf2-4a5b-9073-58d17ac5c3a1'
      }
    ],
    createdAt: new Date(1640259670891),
    button_message: "Install Now"
  },

  /* --- Id: 2 - Political --- */
  2: {
    id: 2,
    creator: '2Ro1Ltf9fNmh4qgTcPRR',
    content: 'Gas prices were WAY higher in 2008, under REPUBLICAN president George W. Bush.\nWeekly gas prices peaked at $4.11 during President George W. Bush’s time in office. Prices were also as low as $1.07 during his presidency.\n\nThe movement of gas prices doesn’t correlate with who’s in office. It’s determined by the balance of supply and demand, and influenced by the health of the economy and OPEC policies.',
    attachments: [
      {
        type: 'image/jpeg',
        url: 'https://firebasestorage.googleapis.com/v0/b/chatbox-v01.appspot.com/o/images%2F2.jpg?alt=media&token=f33aa31c-c15d-4b02-828d-c94bfda1c27f'
      }
    ],
    createdAt: new Date(1640259800476),
    button_message: "Install Now"
  },

  /* --- Id: 3 - Political --- */
  3: {
    id: 3,
    creator: 'nWerxL1cZWDsQMlEU5w0',
    content: '“There were no guns whatsoever” at the Capitol riot on Jan. 6.\n\nPresident Donald Trump claimed on Fox News that there were no guns in the insurrection at the U.S. Capitol on Jan. 6, 2021.\nDuring an on-air conversation with Trump on July 11, "Sunday Morning Futures" host Maria Bartiromo twice broached the topic of whether guns were present during the attack at the Capitol.',
    attachments: [
      {
        type: 'image/jpeg',
        url: 'https://firebasestorage.googleapis.com/v0/b/chatbox-v01.appspot.com/o/images%2F3.jpg?alt=media&token=75b29e05-51f6-4aae-9174-6ff2170a08f1'
      }
    ],
    createdAt: new Date(1640259825388),
    button_message: "Install Now"
  },

  /* --- Id: 4 - Political --- */
  4: {
    id: 4,
    creator: 'TnUpw8Ap6ttd7UOYTtMq',
    content: 'In more than 60 cases, judges “looked at the allegations that Trump was making and determined they were without any merit.”\nA day after a mob of President Donald Trump’s supporters stormed the U.S. Capitol, President-elect Joe Biden spoke about the importance of democratic institutions. He said that one of those pillars was the judiciary system.\nTrump was "truly stunned when the judges he appointed didn\'t do his bidding and instead acted with integrity, following the Constitution, upholding the rule of law," Biden said.',
    attachments: [
      {
        type: 'image/jpeg',
        url: 'https://firebasestorage.googleapis.com/v0/b/chatbox-v01.appspot.com/o/images%2F4.jpg?alt=media&token=19a4f697-4ac6-4d9c-8bec-f7a6c6079608'
      }
    ],
    createdAt: new Date(1640259840395),
    button_message: "Install Now"
  },

  /* --- Id: 5 - Political --- */
  5: {
    id: 5,
    creator: 'RVewILTxvEYGi7Ok534n',
    content: 'There has been “no question of our credibility from our allies around the world” regarding how the U.S. is withdrawing from Afghanistan.\nCurrent leaders of the NATO members that contributed most to the International Security Assistance Force mission in Afghanistan — Germany, the United Kingdom, Italy and France — have not publicly criticized the U.S. response or questioned U.S. credibility.\nBut some members of parliament from governing parties have spoken up. Their criticism hasn’t been targeted just at the United States. Some criticism has also been aimed at NATO and the West in general.',
    attachments: [
      {
        type: 'image/jpeg',
        url: 'https://firebasestorage.googleapis.com/v0/b/chatbox-v01.appspot.com/o/images%2F5.jpg?alt=media&token=80477853-f141-4877-8d51-8c24e6835262'
      }
    ],
    createdAt: new Date(1640259883979),
    button_message: "Install Now"
  },

  /* --- Id: 6 - Political --- */
  6: {
    id: 6,
    creator: '69b1gYCQ6lv5hb4t8Frx',
    product_install_message: 'You are about to install HappyShopper',
    content: 'HappyShopper is a location-based social shopping information app.',
    attachments: [
      {
        type: 'image/jpeg',
        url: 'https://lh3.googleusercontent.com/E0gjXlphm-JI271hmRVtWqPu4FGZd3SmMbYPyIJG_34uQyU74C8Sh0IHN7wu2DIo8qE=w1024-h683-p',
        url1: 'https://firebasestorage.googleapis.com/v0/b/chatbox-v01.appspot.com/o/images%2F6.jpg?alt=media&token=72733d02-48d8-4003-8cf0-b259da300b64'
      }
    ],
    createdAt: new Date(1640259923075),
    button_message: "Install Now"
  },

  /* --- Id: 7 - Covid --- */
  7: {
    id: 7,
    creator: 'TnUpw8Ap6ttd7UOYTtMq',
    content: 'Southwest Airlines announce they will no longer terminate employees over the mandate.\n\nSouthwest announced on Oct. 4 that it would follow the federal vaccine directive, saying that employees "must be fully vaccinated against COVID-19, or be approved for a religious, medical or disability accommodation, by Dec. 8, 2021, to continue employment with the airline."\nOn Oct. 12, Southwest’s CEO said in a television interview that the airline won’t fire employees over the mandate, and that it will help workers with getting an “accommodation,” such as a religious or medical exemption.',
    attachments: [
      {
        type: 'image/jpeg',
        url: 'https://firebasestorage.googleapis.com/v0/b/chatbox-v01.appspot.com/o/images%2F7.jpg?alt=media&token=97e20a36-7f0d-4f50-aac7-0f887e0464fb'
      }
    ],
    createdAt: new Date(1640259947268),
    button_message: "Install Now"
  },

  /* --- Id: 8 - Covid --- */
  8: {
    id: 8,
    creator: '2Ro1Ltf9fNmh4qgTcPRR',
    content: 'Mayo Clinic study shows Pfizer vaccine dropped to 42% effective.\nThe study, which has not yet been peer reviewed, looked at people who had received at least one dose of the two-shot vaccines. It said the Pfizer vaccine’s effectiveness in preventing COVID-19 infection dropped to 42% in July.\nOverall, the study said that both the Pfizer and Moderna vaccines are highly effective in preventing hospitalization.\nAs the virus’ delta variant has taken hold this summer, the vast majority of COVID-19 hospitalizations and deaths have occurred among people who were not vaccinated.',
    attachments: [
      {
        type: 'image/jpeg',
        url: 'https://firebasestorage.googleapis.com/v0/b/chatbox-v01.appspot.com/o/images%2F8.jpg?alt=media&token=b11ffdc6-1f46-4de7-801f-18ca8bbd7e2f'
      }
    ],
    createdAt: new Date(1640259968323),
    button_message: "Install Now"
  },

  /* --- Id: 9 - Covid --- */
  9: {
    id: 9,
    creator: '69b1gYCQ6lv5hb4t8Frx',
    content: '“There is no such thing as a booster. There is a failed product that is sometimes used again in hopes of a different outcome.”\n\nA viral image claimed that COVID-19 vaccines are a "failed product" and, therefore, the vaccines’ booster shots are more of the same.\n"There is no such thing as a booster," read text in an image shared on Instagram. "There is a failed product that is sometimes used again in hopes of a different outcome, which is the definition of insanity."',
    attachments: [
      {
        type: 'image/jpeg',
        url: 'https://firebasestorage.googleapis.com/v0/b/chatbox-v01.appspot.com/o/images%2F9.jpg?alt=media&token=03394040-bef9-48fe-afbf-6dec394b2758'
      }
    ],
    createdAt: new Date(1640259991108),
    button_message: "Install Now"
  },

  /* --- Id: 10 - Covid --- */
  10: {
    id: 10,
    creator: 'RrO8DxMzB1VRpIDpVeed',
    content: 'Studies show good COVID booster effect, waning 2nd-dose protection.\n\nSeveral new studies on the Pfizer/BioNTech mRNA COVID-19 vaccine describe good effectiveness against the Delta (B1617.2) variant after a booster dose and high but waning protection against infection and severe illness 6 months after the second dose.\nOther, much smaller, studies demonstrated the safety of third mRNA vaccine doses. And a new British study on waning two-dose effectiveness coincides with the recent decision by UK officials to recommend booster doses.',
    attachments: [
      {
        type: 'image/jpeg',
        url: 'https://firebasestorage.googleapis.com/v0/b/chatbox-v01.appspot.com/o/images%2F10.jpg?alt=media&token=8a3d3426-32aa-46d2-9517-eecc3808f6be'
      }
    ],
    createdAt: new Date(1640260010653),
    button_message: "Install Now"
  },

  /* --- Id: 11 - Covid --- */
  11: {
    id: 11,
    creator: 'RVewILTxvEYGi7Ok534n',
    content: 'People who are vaccinated for the coronavirus “cannot spread it to you.” - says Joe Biden.\n"My administration is now requiring federal workers to be vaccinated," Biden said on Oct. 7. "We’ve also required federal contractors to be vaccinated. ... We’re requiring active duty military to be vaccinated."\nBiden then addressed vaccine requirements for medical workers: "We’re making sure health care workers are vaccinated, because if you seek care at a health care facility, you should have the certainty that the people providing that care are protected from COVID and cannot spread it to you."',
    attachments: [
      {
        type: 'image/jpeg',
        url: 'https://firebasestorage.googleapis.com/v0/b/chatbox-v01.appspot.com/o/images%2F11.jpg?alt=media&token=eb3dccb8-3b2e-4779-84b2-a7c89478b563'
      }
    ],
    createdAt: new Date(1640260031356),
    button_message: "Install Now"
  },

  /* --- Id: 12 - Covid --- */
  12: {
    id: 12,
    creator: 'nWerxL1cZWDsQMlEU5w0',
    content: 'Biden orders dishonorable discharge for 46% of troops who refuse vaccine.\n\nA new rumor on social media claims that President Joe Biden commanded the military to dishonorably discharge service members who reject the Pentagon’s COVID-19 vaccine mandate.',
    attachments: [
      {
        type: 'image/jpeg',
        url: 'https://firebasestorage.googleapis.com/v0/b/chatbox-v01.appspot.com/o/images%2F12.jpg?alt=media&token=b6264b73-c6cd-4ca6-9bbd-d8d6c3154795'
      }
    ],
    createdAt: new Date(1640260074740),
    button_message: "Install Now"
  }
}

const USERS = {
  'RrO8DxMzB1VRpIDpVeed': {
    id: 'RrO8DxMzB1VRpIDpVeed',
    fake: true,
    names: ['James', 'Willie', 'Chad', 'Zachary', 'Mathew',
      'John', 'Ralph', 'Jacob', 'Corey', 'Tyrone',
      'Robert', 'Lawrence', 'Lee', 'Herman', 'Darren'],
    bio: 'Guitarist',
    birthYear: 1995,
    // createdAt
    email: '6a27@outlook.com',
    friends: [],
    gender: 'Mr.',
    prolificId: '-',
    qualtricsId: '-',
  },
  '2Ro1Ltf9fNmh4qgTcPRR': {
    id: '2Ro1Ltf9fNmh4qgTcPRR',
    fake: true,
    names: ['Michael', 'Nicholas', 'Melvin', 'Maurice', 'Lonnie',
      'William', 'Roy', 'Alfred', 'Vernon', 'Lance',
      'David', 'Benjamin', 'Kyle', 'Roberto', 'Cody'],
    bio: 'Social worker',
    birthYear: 1996,
    // createdAt
    email: '52g7@gmail.com',
    friends: [],
    gender: 'Mr.',
    prolificId: '-',
    qualtricsId: '-',
  },
  'nWerxL1cZWDsQMlEU5w0': {
    id: 'nWerxL1cZWDsQMlEU5w0',
    fake: true,
    names: ['Richard', 'Bruce', 'Francis', 'Clyde', 'Julio',
      'Charles', 'Brandon', 'Bradley', 'Glen', 'Kelly',
      'Joseph', 'Adam', 'Jesus', 'Hector', 'Kurt'],
    bio: 'Marketing dept.',
    birthYear: 1999,
    // createdAt
    email: '4o4@outlook.com',
    friends: [],
    gender: 'Mr.',
    prolificId: '-',
    qualtricsId: '-',
  },
  'TnUpw8Ap6ttd7UOYTtMq': {
    id: 'TnUpw8Ap6ttd7UOYTtMq',
    fake: true,
    names: ['Mary', 'Katherine', 'Josephine', 'Ana', 'Heidi',
      'Patricia', 'Joan', 'Thelma', 'Renee', 'Glenda',
      'Linda', 'Ashley', 'Shannon', 'Ida', 'Lydia'],
    bio: 'Sales',
    birthYear: 1998,
    // createdAt
    email: '4ty7@gmail.com',
    friends: [],
    gender: 'Ms.',
    prolificId: '-',
    qualtricsId: '-',
  },
  'RVewILTxvEYGi7Ok534n': {
    id: 'RVewILTxvEYGi7Ok534n',
    fake: true,
    names: ['Barbara', 'Judith', 'Sheila', 'Vivian', 'Viola',
      'Elizabeth', 'Rose', 'Ethel', 'Roberta', 'Courtney',
      'Jennifer', 'Janice', 'Ellen', 'Holly', 'Marian'],
    bio: 'Frontend developer',
    birthYear: 1991,
    // createdAt
    email: '1991b@reddit.com',
    friends: [],
    gender: 'Ms.',
    prolificId: '-',
    qualtricsId: '-',
  },
  '69b1gYCQ6lv5hb4t8Frx': {
    id: '69b1gYCQ6lv5hb4t8Frx',
    fake: true,
    names: ['Maria', 'Kelly', 'Elaine', 'Brittany', 'Stella',
      'Susan', 'Nicole', 'Marjorie', 'Melanie', 'Caroline',
      'Margaret', 'Judy', 'Carrie', 'Loretta', 'Dora'],
    bio: 'Photography',
    birthYear: 1999,
    // createdAt
    email: '123abc@gmail.com',
    friends: [],
    gender: 'Ms.',
    prolificId: '-',
    qualtricsId: '-',
  }
}

// const POST_QUESTIONS = {
//   1: { id: 1, question: 'I think this post is correct' },
//   2: { id: 2, question: 'I think this post is interesting'},
//   3: { id: 3, question: 'I think this post will generate discussion among my friends'},
//   4: { id: 4, question: 'I think this post will make me look good'},
//   5: { id: 5, question: 'I agree with this post'},
//   6: { id: 6, question: 'I do not know much about this post'},
//   7: { id: 7, question: 'I am very knowledgeable about the context discussed in the post'},
//   10: { id: 10, question: 'I feel that the post is controversial in nature'},
//   11: { id: 11, question: 'I think this post is popular'},
// }


const AD_POST_QUESTIONS = {
  1: { 
    id: 1,
    question: 'The post is intrusive'
  },
  2: { 
    id: 2, 
    question: 'The post is forced on me'
  },
  3: {
    id: 3, 
    question: 'The post is unwelcome'
  },
  4: { 
    id: 4, 
    question: 'The post makes me feel uncomfortable'
  },
  5: { 
    id: 5, 
    question: 'The post forces me to respond'
  },
  6: { 
    id: 6, 
    question: 'The post infringed on my freedom'
  },
  7: { 
    id: 7, 
    question: 'The post threatened my freedom'
  },
  8: { 
    id: 8, 
    question: 'The post is of high quality'
  },
  9: { 
    id: 9, 
    question: 'I have similar preferences about the featured product with my friend(s) who liked the post. (Select N/A if no friend(s) liked the post.)'
  },
  10: { 
    id: 10, 
    question: "The ‘likes’ endorsing the post seem credible to me. (Select N/A if no one liked the post.)"
  },
  11: { 
    id: 11, 
    question: "The ‘likes’ endorsing the post seem suspicious to me. (Select N/A if no one liked the post.)"
  },
  12: { 
    id: 12, 
    question: "The ‘likes’ endorsing the post seem to be the firm’s advertising strategy. (Select N/A if no one liked the post.)"
  },
  13: { 
    id: 13, 
    question: "The ‘likes’ endorsing the post seem to be genuine. (Select N/A if no one liked the post.)"
  },
  14: { 
    id: 14, 
    question: "I feel pressured to conform because of the 'likes' endorsing this post. (Select N/A if no one liked the post.)"
  },
  15: { 
    id: 15, 
    question: "I don't feel pressured to conform because of the 'likes' endorsing this post. (Select N/A if no one liked the post.)"
  },
  16: { 
    id: 16, 
    question: "My friend's ‘like(s)’ endorsing the post seem credible to me. (Select N/A if no friend(s) liked the post.)"
  },
  17: { 
    id: 17, 
    question: "My friend's ‘like(s)’ endorsing the post seem suspicious to me. (Select N/A if no friend(s) liked the post.)"
  },
  18: { 
    id: 18, 
    question: "My friend's ‘like(s)’ endorsing the post seem to be the firm’s advertising strategy. (Select N/A if no friend(s) liked the post.)"
  },
  19: { 
    id: 19, 
    question: "My friend's ‘like(s)’ endorsing the post seem to be genuine. (Select N/A if no friend(s) liked the post.)"
  },
  20: { 
    id: 20, 
    question: "I feel pressured to conform because of my friend's 'like(s)' endorsing this post. (Select N/A if no friend(s) liked the post.)"
  },
  21: { 
    id: 21, 
    question: "I don't feel pressured to conform because of my friend's 'like(s)' endorsing this post. (Select N/A if no friend(s) liked the post.)"
  },
  22: { 
    id: 22, 
    question: "Seeing that both friends and strangers 'like' the post makes me feel the post is credible. (Select N/A if not both strangers and friend(s) liked the post.)"
  },
  23: { 
    id: 23, 
    question: "Seeing that both friends and strangers 'like' the post makes me feel this is the firm's advertising strategy. (Select N/A if not both strangers and friend(s) liked the post.)"
  }
}



const DEMO_QUESTIONS = {
  1: {
    id: 1,
    question: 'What is your gender?',
    options: ['Male', 'Female'],
  },
  2: {
    id: 2,
    question: 'What is your age?',
    options: ['18-20', '21-30', '31-40', '41-50', '51-60', '61-70', '71 or above'],
  },
  3: {
    id: 3,
    question: "Your last year's pre-tax income",
    options: ['Less than $10,000', '$10,000 - $25,000', '$25,000 - $50,000', '$50,000 - $75,000','$75,000 - $100,000', '$100,000 or above','Prefer not to answer'],
  },
  4: {
    id: 4,
    question: 'Your highest achieved education level?',
    options: ['Some primary education or less', 'Primary education', 'Some secondary education', 'Secondary education', 'Some college but no degree', "Bachelor's degree", "Master's degree", 'Doctoral Degree', 'Professional degree'],
  },
  5: {
    id: 5,
    question: 'How often do you use Facebook?',
    options: ['Less than 1 hour a week', 'Between 1 - 5 hours a week', 'Between 5 - 10 hours a week', 'More than 10 hours a week', "I don't use Facebook"],
  },
  6: {
    id: 6,
    question: "How often do you read a website's privacy policy before signing up?",
    options: ['Almost never', 'Not often', 'Sometimes', 'Often', 'Almost always']
  },
  7: {
    id: 7,
    question: "How often do you remove cookies from your browser?",
    options: ['Almost never', 'Not often', 'Sometimes', 'Often', 'Almost always']
  },
  8: {
    id: 8,
    question: "In general, how concerned are you about your privacy while using the internet?",
    options: ['Not concerned at all', 'Not very concerned', 'Indifferent', 'Somewhat concerned', 'Very concerned']
  },

  /*
  9: {
    id: 9,
    question: "In general, when an ad receives 'likes' from both strangers and friends, I feel the ad is more credible.",
    options: ['Strongly disagree', 'Somewhat disagree', 'Neither agree nor disagree', 'Somewhat agree', 'Strongly agree']
  },
  10: {
    id: 10,
    question: "In general, when an ad receives 'likes' from both strangers and friends, this seems to be the firm’s advertising strategy.",
    options: ['Strongly disagree', 'Somewhat disagree', 'Neither agree nor disagree', 'Somewhat agree', 'Strongly agree']
  },

  */

  9: {
    id: 9,
    question: 'We would like to thank you for taking your time to complete the survey for us. This will help us advance our understanding of social media. In order to ensure the survey quality, we would like you to select "Twitter" as the answer for the following question to show you are reading the instructions carefully.\n What platform was being studied in the survey you just took?',
    options: ['Facebook', 'Twitter', 'Snapchat', 'Tiktok', 'Instagram']
  },
  10: {
    id: 10,
    question: 'Please select the largest number below.',
    options: ['2019', '2023', '9999']
  }
}



/*


const POLITICS_QUESTIONS = {
  1: {
    id: 1,
    question: 'Generally speaking, how would you describe your own political point of view?',
    options: ['Very liberal', 'Liberal', 'Somewhat liberal', 'Moderate', 'Somewhat conservative', 'Conservative', 'Very conservative'],
  },
  2: {
    id: 2,
    question: 'In 2020, Joe Biden ran on the Democratic ticket against Donald Trump for the Republicans. Do you remember for sure whether or not you voted in that election?',
    options: ['Yes, I for sure voted in the 2020 Presidential Election', 'No, I am not sure I voted in the 2020 Presidential Election'],
  },
  3: {
    id: 3,
    question: 'Who did you vote for in the 2020 Presidential election?',
    options: ['Joe Biden', 'Donald Trump', 'Other:', 'Did not vote'],
    emptyBlankError: 'Please mention the candidate you voted for',
  },
  4: {
    id: 4,
    question: 'Generally speaking, how interested are you in politics?',
    options: ['Extremely interested', 'Very interested', 'Somewhat interested', 'Not very interested', 'Not at all interested'],
  },
  5: {
    id: 5,
    question: 'How often would you say you follow what\'s going on in government and public affairs?',
    options: ['Most of the time', 'Some of the time', 'Only now and then', 'Hardly at all'],
  },
  6: {
    id: 6,
    question: 'Generally speaking do you think of yourself as a Republican, a Democrat, an Independent, or what?',
    options: ['Republican', 'Democrat', 'Independent', 'Other:'],
  },
  7: {
    id: 7,
    question: 'Which of the following best describes your political preference?',
    options: ['Strongly democratic', 'Democratic', 'Lean democratic', 'Lean republican', 'Republican', 'Strongly republican'],
  },
  8: {
    id: 8,
    question: 'What percentage of your social circle (friends and family) do you think votes like yourself? (For example, if you vote Democrat, what percentage also votes Democrat / if you vote Republican, what percentage also votes Republican?)',
    options: ['0%', '10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '90%', '100%'],
  },
  9: {
    id: 9,
    question: 'My political attitudes and beliefs are an important reflection of who I am',
    options: ['Strongly agree', 'Somewhat agree', 'Neither agree nor disagree', 'Somewhat disagree', 'Strongly disagree'],
  },
  10: {
    id: 10,
    question: 'Whose responsibility is it to nominate judges to Federal Courts?',
    options: ['President', 'Congress', 'The Supreme Court'],
  },
}

const COVID_QUESTIONS = {
  1: {
    id: 1,
    question: 'Have you ever tested POSITIVE for COVID-19?',
    options: ['Yes', 'No', 'Prefer not to answer'],
  },
  2: {
    id: 2,
    question: 'Please rate the severity of your COVID-19 symptoms',
    options: ['Never had covid', 'No symptoms', 'Mild symptoms', 'Severe symptoms managed at home', 'Severe symptoms requiring hospitalization'],
  },
  3: {
    id: 3,
    question: 'Number of people you personally know diagnosed with COVID-19',
    options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'More:', 'Prefer not to answer'],
  },
  4: {
    id: 4,
    question: 'Rate the symptoms of the person who is/was most sick',
    options: ['Mild symptoms managed at home', 'Severe symptoms managed at home', 'Severe symptoms requiring hospitalization', 'A person I know has died of coronavirus', 'Prefer not to answer'],
  },
  5: {
    id: 5,
    question: 'Are you vaccinated?',
    options: ['Yes', 'No', 'Prefer not to answer'],
  },
  6: {
    id: 6,
    question: 'Approximately how many total people in US have been reported to be infected from Covid?',
    options: ['Less than 15 million', '15 - 25 million', 'More than 25 million', 'Don\'t know'],
  },
}


*/

//export { POSTS, USERS, POST_QUESTIONS, POLITICS_QUESTIONS, COVID_QUESTIONS }
export { POSTS, USERS, AD_POST_QUESTIONS, DEMO_QUESTIONS }
